export const HUMANOID_GROWTH_START_YEAR = 2000;
export const HUMANOID_GROWTH_END_YEAR = 2026;

export const humanoidCompanyGrowthCompanies = [
  {
    id: "tmsuk",
    company: "TMSUK",
    foundedYear: 2000,
    foundedDate: null,
    country: "Japan",
    region: "Japan",
    robotName: "Service and humanoid-style robot platforms",
    robotType: "semi_humanoid",
    status: "active",
    sourceUrl: "https://www.tmsuk.co.jp/en/about/",
    sourceName: "Company profile",
    verifiedAt: "2026-09-29",
  
"foundingYearVerified": true
},
  {
    id: "vstone",
    company: "Vstone",
    foundedYear: 2000,
    foundedDate: "2000-08-04",
    country: "Japan",
    region: "Japan",
    robotName: "Robovie humanoid series",
    robotType: "biped",
    status: "active",
    sourceUrl: "https://www.vstone.co.jp/company/",
    sourceName: "Company profile (Japanese)",
    verifiedAt: "2026-09-29",
  
"foundingYearVerified": true
},
  {
    id: "speecys",
    company: "Speecys",
    foundedYear: 2001,
    foundedDate: null,
    country: "Japan",
    region: "Japan",
    robotName: "Networked humanoid and Motion Figure systems",
    robotType: "biped",
    status: "active",
    sourceUrl: "https://spectrum.ieee.org/speecys-robotic-action-figures",
    sourceName: "IEEE Spectrum historical report",
    verifiedAt: "2026-09-29",
  
"foundingYearVerified": true
},
  {
    id: "robo-garage",
    company: "Robo Garage",
    foundedYear: 2003,
    foundedDate: null,
    country: "Japan",
    region: "Japan",
    robotName: "Small humanoid robot platforms",
    robotType: "social_humanoid",
    status: "active",
    sourceUrl: "https://www.kyoto-u.ac.jp/125th/en/people/01/",
    sourceName: "Kyoto University founder profile",
    verifiedAt: "2026-09-29",
  
"foundingYearVerified": true
},

  {
    id: "tesla",
    company: "Tesla",
    foundedYear: 2003,
    foundedDate: null,
    country: "United States",
    region: "USA",
    robotName: "Optimus",
    robotType: "biped",
    status: "active",
    sourceUrl: "https://www.tesla.com/sites/default/files/about/legal/2020-california-transparency-supply-chain-act-statement.pdf",
    sourceName: "Tesla corporate statement",
    verifiedAt: "2026-09-29",
  
"foundingYearVerified": true
},
  {
    id: "agility-robotics",
    company: "Agility Robotics",
    foundedYear: 2015,
    foundedDate: null,
    country: "United States",
    region: "USA",
    robotName: "Digit",
    robotType: "biped",
    status: "active",
    sourceUrl: "https://www.agilityrobotics.com/company-overview",
    sourceName: "Company history",
    verifiedAt: "2026-09-29",
  
"foundingYearVerified": true
},
  {
    id: "apptronik",
    company: "Apptronik",
    foundedYear: 2016,
    foundedDate: null,
    country: "United States",
    region: "USA",
    robotName: "Apollo",
    robotType: "biped",
    status: "active",
    sourceUrl: "https://apptronik.com/news-collection/apptronik-and-mercedes-benz-enter-commercial-agreement",
    sourceName: "Company background in official release",
    verifiedAt: "2026-09-29",
  
"foundingYearVerified": true
},
  {
    id: "figure-ai",
    company: "Figure AI",
    foundedYear: null,
    foundedDate: null,
    country: "United States",
    region: "USA",
    robotName: "Figure humanoid series",
    robotType: "biped",
    status: "active",
    sourceUrl: "https://www.figure.ai/",
    sourceName: "Figure AI",
    verifiedAt: "2026-08-13",
  
"foundingYearVerified": false,
"foundingReviewNote": "The cited source did not establish a founding year in this review."
},
  {
    id: "persona-ai",
    company: "Persona AI",
    foundedYear: null,
    foundedDate: null,
    country: "United States",
    region: "USA",
    robotName: "Heavy-industry humanoid platform",
    robotType: "biped",
    status: "active",
    sourceUrl: "https://persona.ai/",
    sourceName: "Persona AI",
    verifiedAt: "2026-08-13",
  
"foundingYearVerified": false,
"foundingReviewNote": "The cited source did not establish a founding year in this review."
},
  {
    id: "foundation",
    company: "Foundation",
    foundedYear: null,
    foundedDate: null,
    country: "United States",
    region: "USA",
    robotName: "Phantom",
    robotType: "biped",
    status: "active",
    sourceUrl: "https://foundation.bot/",
    sourceName: "Foundation",
    verifiedAt: "2026-08-13",
  
"foundingYearVerified": false,
"foundingReviewNote": "The cited source did not establish a founding year in this review."
},

  {
    id: "xiaomi",
    company: "Xiaomi",
    foundedYear: 2010,
    foundedDate: null,
    country: "China",
    region: "China",
    robotName: "CyberOne",
    robotType: "biped",
    status: "active",
    sourceUrl: "https://www.mi.com/global/about/",
    sourceName: "Company history",
    verifiedAt: "2026-09-29",
  
"foundingYearVerified": true
},
  {
    id: "ubtech",
    company: "UBTECH Robotics",
    foundedYear: 2012,
    foundedDate: null,
    country: "China",
    region: "China",
    robotName: "Walker series",
    robotType: "biped",
    status: "active",
    sourceUrl: "https://jimu.ubtrobot.com/jimu/parentManage/privacy.html",
    sourceName: "UBTECH company identification",
    verifiedAt: "2026-09-29",
  
"foundingYearVerified": true
},
  {
    id: "xpeng",
    company: "XPeng",
    foundedYear: 2014,
    foundedDate: null,
    country: "China",
    region: "China",
    robotName: "IRON",
    robotType: "biped",
    status: "active",
    sourceUrl: "https://www.xpeng.com/ie/about-xpeng",
    sourceName: "Company history",
    verifiedAt: "2026-09-29",
  
"foundingYearVerified": true
},
  {
    id: "fourier-intelligence",
    company: "Fourier Intelligence",
    foundedYear: null,
    foundedDate: null,
    country: "China",
    region: "China",
    robotName: "GR humanoid series",
    robotType: "biped",
    status: "active",
    sourceUrl: "https://www.fftai.com/",
    sourceName: "Fourier Intelligence",
    verifiedAt: "2026-08-13",
  
"foundingYearVerified": false,
"foundingReviewNote": "The cited source did not establish a founding year in this review."
},
  {
    id: "cloudminds",
    company: "CloudMinds",
    foundedYear: null,
    foundedDate: null,
    country: "China",
    region: "China",
    robotName: "XR-1",
    robotType: "wheeled_humanoid",
    status: "active",
    sourceUrl: "https://www.cloudminds.com/",
    sourceName: "CloudMinds",
    verifiedAt: "2026-08-13",
  
"foundingYearVerified": false,
"foundingReviewNote": "The cited source did not establish a founding year in this review."
},
  {
    id: "unitree-robotics",
    company: "Unitree Robotics",
    foundedYear: 2016,
    foundedDate: null,
    country: "China",
    region: "China",
    robotName: "H1, G1 and R1",
    robotType: "biped",
    status: "active",
    sourceUrl: "https://www.unitree.com/about/",
    sourceName: "Company history",
    verifiedAt: "2026-09-29",
  
"foundingYearVerified": true
},
  {
    id: "leju-robotics",
    company: "Leju Robotics",
    foundedYear: null,
    foundedDate: null,
    country: "China",
    region: "China",
    robotName: "KUAVO, AELOS and PANDO",
    robotType: "biped",
    status: "active",
    sourceUrl: "https://www.lejurobot.com/en",
    sourceName: "Leju Robotics",
    verifiedAt: "2026-08-13",
  
"foundingYearVerified": false,
"foundingReviewNote": "The cited source did not establish a founding year in this review."
},
  {
    id: "agibot",
    company: "AgiBot / Zhiyuan Robotics",
    foundedYear: 2023,
    foundedDate: null,
    country: "China",
    region: "China",
    robotName: "A2 and X series",
    robotType: "biped",
    status: "active",
    sourceUrl: "https://store.agibot.com/pages/about-us",
    sourceName: "Company history",
    verifiedAt: "2026-09-29",
  
"foundingYearVerified": true
},
  {
    id: "engineai",
    company: "EngineAI",
    foundedYear: null,
    foundedDate: null,
    country: "China",
    region: "China",
    robotName: "SA01, SE01 and PM01",
    robotType: "biped",
    status: "active",
    sourceUrl: "https://www.engineai.com.cn/",
    sourceName: "EngineAI",
    verifiedAt: "2026-08-13",
  
"foundingYearVerified": false,
"foundingReviewNote": "The cited source did not establish a founding year in this review."
},

  {
    id: "rainbow-robotics",
    company: "Rainbow Robotics",
    foundedYear: 2011,
    foundedDate: null,
    country: "South Korea",
    region: "South Korea",
    robotName: "HUBO lineage",
    robotType: "biped",
    status: "active",
    sourceUrl: "https://news.samsung.com/global/samsung-electronics-to-become-largest-shareholder-in-rainbow-robotics-accelerating-future-robot-development",
    sourceName: "Samsung shareholder announcement",
    verifiedAt: "2026-09-29",
  
"foundingYearVerified": true
},

  {
    id: "pal-robotics",
    company: "PAL Robotics",
    foundedYear: 2004,
    foundedDate: null,
    country: "Spain",
    region: "Europe",
    robotName: "TALOS and ARI",
    robotType: "biped",
    status: "active",
    sourceUrl: "https://pal-robotics.com/news/press-release-pal-robotics-20-years-anniversary/",
    sourceName: "Company anniversary release",
    verifiedAt: "2026-09-29",
  
"foundingYearVerified": true
},
  {
    id: "engineered-arts",
    company: "Engineered Arts",
    foundedYear: null,
    foundedDate: null,
    country: "United Kingdom",
    region: "Europe",
    robotName: "Ameca and RoboThespian",
    robotType: "social_humanoid",
    status: "active",
    sourceUrl: "https://engineeredarts.com/about",
    sourceName: "Engineered Arts",
    verifiedAt: "2026-08-13",
  
"foundingYearVerified": false,
"foundingReviewNote": "The cited source did not establish a founding year in this review."
},
  {
    id: "aldebaran",
    company: "Aldebaran Robotics",
    foundedYear: null,
    foundedDate: null,
    country: "France",
    region: "Europe",
    robotName: "NAO and Pepper",
    robotType: "social_humanoid",
    status: "closed",
    sourceUrl: "https://aldebaran.com/",
    sourceName: "Aldebaran",
    verifiedAt: "2026-08-13",
  
"foundingYearVerified": false,
"foundingReviewNote": "The cited source did not establish a founding year in this review."
},
  {
    id: "wandercraft",
    company: "Wandercraft",
    foundedYear: 2012,
    foundedDate: null,
    country: "France",
    region: "Europe",
    robotName: "Calvin",
    robotType: "biped",
    status: "active",
    sourceUrl: "https://www.wandercraft.eu/articles/renault-group-finalises-a-strategic-partnership-with-wandercraft",
    sourceName: "Company background in official release",
    verifiedAt: "2026-09-29",
  
"foundingYearVerified": true
},
  {
    id: "1x-technologies",
    company: "1X Technologies",
    foundedYear: 2014,
    foundedDate: null,
    country: "Norway",
    region: "Europe",
    robotName: "EVE and NEO",
    robotType: "biped",
    status: "active",
    sourceUrl: "https://www.1x.tech/about",
    sourceName: "Company history",
    verifiedAt: "2026-09-29",
  
"foundingYearVerified": true
},
  {
    id: "pollen-robotics",
    company: "Pollen Robotics",
    foundedYear: 2016,
    foundedDate: null,
    country: "France",
    region: "Europe",
    robotName: "Reachy 2",
    robotType: "wheeled_humanoid",
    status: "active",
    sourceUrl: "https://pollen-robotics.com/about-us/",
    sourceName: "Company history",
    verifiedAt: "2026-09-29",
  
"foundingYearVerified": true
},
  {
    id: "neura-robotics",
    company: "NEURA Robotics",
    foundedYear: 2019,
    foundedDate: null,
    country: "Germany",
    region: "Europe",
    robotName: "4NE1",
    robotType: "biped",
    status: "active",
    sourceUrl: "https://neura-robotics.com/about-us/",
    sourceName: "Company history",
    verifiedAt: "2026-09-29",
  
"foundingYearVerified": true
},
  {
    id: "oversonic-robotics",
    company: "Oversonic Robotics",
    foundedYear: 2020,
    foundedDate: null,
    country: "Italy",
    region: "Europe",
    robotName: "RoBee",
    robotType: "biped",
    status: "active",
    sourceUrl: "https://www.oversonicrobotics.com/who-we-are/",
    sourceName: "Company history",
    verifiedAt: "2026-09-29",
  
"foundingYearVerified": true
},
  {
    id: "enchanted-tools",
    company: "Enchanted Tools",
    foundedYear: null,
    foundedDate: null,
    country: "France",
    region: "Europe",
    robotName: "Mirokaï",
    robotType: "wheeled_humanoid",
    status: "active",
    sourceUrl: "https://enchanted.tools/",
    sourceName: "Enchanted Tools",
    verifiedAt: "2026-08-13",
  
"foundingYearVerified": false,
"foundingReviewNote": "The cited source did not establish a founding year in this review."
},
];

export const humanoidGrowthRegions = ["Global", "China", "USA", "Japan", "South Korea", "Europe"];

export function companiesForGrowthRegion(region = "Global") {
  if (region === "Global") return humanoidCompanyGrowthCompanies;
  return humanoidCompanyGrowthCompanies.filter((company) => company.region === region);
}

export function cumulativeHumanoidCompanySeries(region = "Global") {
  const companies = companiesForGrowthRegion(region);
  const years = Array.from(
    { length: HUMANOID_GROWTH_END_YEAR - HUMANOID_GROWTH_START_YEAR + 1 },
    (_, index) => HUMANOID_GROWTH_START_YEAR + index,
  );
  let cumulative = 0;
  return years.map((year) => {
    const founded = companies
      .filter((company) => company.foundedYear === year)
      .sort((a, b) => a.company.localeCompare(b.company));
    cumulative += founded.length;
    return { year, total: cumulative, founded };
  });
}

export function humanoidGrowthTotalsByRegion() {
  return Object.fromEntries(
    humanoidGrowthRegions
      .filter((region) => region !== "Global")
      .map((region) => [region, companiesForGrowthRegion(region).filter((company) => Number.isFinite(company.foundedYear)).length]),
  );
}
